(function () {
    'use strict';

    var hasOwnProperty = Object.prototype.hasOwnProperty;

    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    };

    window.Enum = function Enum(obj) {
        var that = this;
        if (!(that instanceof Enum))
            return new Enum(obj);

        Object.defineProperty(that, '$metadata', { enumerable: false, writable: true, value: {} });

        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                var meta = obj[key];
                meta = Array.isArray(meta) ? { value: meta[0], displayName: meta[1], shortName: meta[2] } :
                    typeof meta !== 'object' ? { value: meta } :
                    meta;

                meta.name = key;
                meta.value = meta.value != null ? meta.value : key;
                that.$metadata[that[key] = meta.value] = meta;
            }
        }
     
    };

    Object.defineProperty(Array.prototype, 'remove', {
        enumerable: false,
        value: function remove(value) {
            var index = this.indexOf(value);
            if (index !== -1)
                this.splice(index, 1);
        }
    });
})();